<template>
  <div>
    <div class="tab_content_semi" style="width: 240px;">
      <div v-if="Options.boxStyle.width">
        <TreeView v-if="Trees && Trees.length > 0" :model="Trees" :options="Options"></TreeView>
        <h5 class="none_ts" v-else>
          <img src="@/assets/images/none_data.jpg" alt="">
        </h5>
      </div>
    </div><!-- gap elimanated
 --><div class="tab_content_semi">
    <div style="padding-top: 10px; padding-left: 5px;">
      <input type="radio" value="销售组" v-model="outputs.post" class="actions-select" :class="{'focus': outputs.post == '销售组'}" style="float: none; top: 0px;"> 销售组
      <input type="radio" value="技术组" v-model=" outputs.post" class="actions-select" :class="{'focus': outputs.post == '技术组'}" style="float: none; top: 0px;"> 技术组
      <span class="xo-table-btn" v-debounce-click @click="search(outputs)">搜索</span>
    </div>
    <div style="height: 218px; padding: 5px; overflow: scroll;" :style="boxHeight">
      <tag-picker :initials="tags" @selected="getTagSelected"></tag-picker>
    </div>
    </div>
  </div>
</template>
<script>
  import TreeView from '@/components/common/treeview/index.vue'
  import TagPicker from '@/components/byl/tagPicker/simplePicker'
  import clonedeep from 'lodash.clonedeep'
  import difference from 'lodash.differenceby'
  import utils from '@/utils'
  export default {
    props: ['initials', 'options', 'treemenu', 'tags'],
    components: { TreeView, TagPicker },
    data () {
      return {
        Options: {},
        Trees: [],
        outputs: {
          post: '销售组',
          deps: [],
          tags: []
        }
      }
    },
    created () {
      this.Trees = clonedeep(this.treemenu)
      this.Options = clonedeep(this.options)
      this.Options.nodeSelected = this.nodeChecked
      this.Options.selectedNodes = []
      // this.Options.boxStyle.height = '380px'
    },
    computed: {
      boxHeight () {
        return {
          height: (this.Options.boxStyle.height) ? this.Options.boxStyle.height : '380px'
        }
      }
    },
    methods: {
      nodeChecked (check, val) {
        var that = this
        if (val) {
          if (this.Options.semiCheck && val.children) {
            var r = []
            r.push(val) // 要将点击的节点(自己)加入数组
            var result = utils.flattern(val.children) // 将数组里的children取出来拉平
            if (check) {
              if (that.outputs.deps && that.outputs.deps.length > 0) { // 原来就有值
                that.outputs.deps = that.outputs.deps.concat(r.concat(result))
              } else {
                that.outputs.deps = r.concat(result)
              }
            } else {
              that.outputs.deps = difference(that.outputs.deps, r.concat(result), 'id')  // 求差集
            }
          } else { // 没有children的节点被点中
            that.itemChecked(check, val)
          }
        }
      },
      itemChecked (check, item) {
        var idIndex = utils.findElem(this.outputs, 'id', item.id)
        if (check) {
          if (idIndex > -1) { /* 已存在的item不能再添加了 */
            return false;
          } else {
            this.outputs.deps.push(item)
          }
        } else {
          this.outputs.deps.splice(idIndex, 1)
        }
      },
      getTagSelected (arr) {
        this.outputs.tags = arr
      },
      search (arr) {
        this.$emit('changed', arr)
      }
    }
  }
</script>
<style scoped>
  @import './index.css';
</style>



// WEBPACK FOOTER //
// src/components/byl/rangeManip/exactSearch.vue